import { ActionReducer } from '@ngrx/store';
import { logoutUserSuccess } from '../actions/user.action';

export function logout(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    // if the action type is logout success then the state is cleared
    if (action.type === logoutUserSuccess.type) {
      return reducer(undefined, action);
    }
    return reducer(state, action);
  };
}